<template>
  <div
    :class="horizon ? 'flex-row justify-between w-full' : 'flex-col justify-start'"
    class="flex last:mr-0 mr-12 sm:mr-0"
  >
    <div class="flex items-center mb-2">
      <t-dropdown>
        <div
          slot="trigger"
          slot-scope="{
            mousedownHandler,
            focusHandler,
            blurHandler,
            keydownHandler
          }"
        >
          <i class="icon-small-calendar mr-1" />
          <label class="mr-1 text-gray-500 text-sm">
            {{ title }}
          </label>
          <w-button
            v-if="showDropdown"
            variant="icon"
            @blur="blurHandler"
            @focus="focusHandler"
            @keydown="keydownHandler"
            @mousedown="mousedownHandler"
          >
            <i class="cursor-pointer icon-dropdown" />
          </w-button>
        </div>

        <template>
          <slot v-if="!!$slots.dropdown" name="dropdown" />
          <ul v-else>
            <li
              v-for="(item, item_index) in dropdownListItems"
              :key="`dropdown-item-${title}-${item_index}}`"
              class="border-b border-secondary-100 flex items-center p-2 last:border-b-0"
            >
              <span class="bg-secondary-100 h-1.5 mr-2 rounded-full w-1.5"></span>
              <displayed-time-format :period="item" />
            </li>
          </ul>
        </template>
      </t-dropdown>
    </div>
    <displayed-time-format :period="displayedPeriod" />
  </div>
</template>

<script>
import TimePeriodDisplay from './TimePeriodDisplay';

export default TimePeriodDisplay;
</script>

<style lang="scss" scoped>
@import 'TimePeriodDisplay';
</style>
